import React from "react";
import {AdminCompanyGrid} from "./AdminCompanyGrid";
import {getAllCompanies} from "../../../services/AdminService";
import {Container} from "react-bootstrap";


export const AdminCompanyDashboard = () => {
    const [companies, setCompanies] = React.useState([]);
    const [loading, setLoading] = React.useState(false);


    const fetchCompanies = React.useCallback(async () => {
        try {
            setLoading(true);
            const allCompanies = await getAllCompanies();


            setCompanies(allCompanies);
            setLoading(false);
        } catch (e) {

        }
    })
    React.useEffect(() => {
        fetchCompanies();
    }, []);


    return (
        <Container>
            <AdminCompanyGrid companies={companies}/>
        </Container>
    )
}
